<template>
  <div class="custSalesMain">

    <div class="custSalesDisplay" :style="{ 'width' : (showDetails ? '60%' : ' 100%') }">
      <div class="buttonBox" v-if="!viewMode">
        <button @click="buttonClick('new')">+</button>
        <button @click="buttonClick('delete')" style="margin-left: 5px;">-</button>
      </div>
      <div class="custSalesTabulatorMain">
        <Tabulator :additionalColumn="additionalButtons" class="custSalesTabulator" tableTitle="Sales & Service Teams" tableID="cu_salesservice" :tableData="data.SalesServiceData" :selectedRow.sync="selectedTeams"
                   @cellButtonClick="cellClick" /><!--:hideColumns="[ 'SalesAction' ]"-->
      </div>
    </div>

    <div class="custSalesDetails">
      <div class="buttonBox" style="justify-content: flex-end;">
        <button @click="buttonClick('ok')">{{okButtonTitle}}</button>
        <button @click="buttonClick('cancel')" style="margin-left: 5px;">Cancel</button>
      </div>
      <InputQuery placeholder="Customer System" :items="data.SystemData" itemKey="System" descKey="Application Name" :selectedObject.sync="data.selectedSystem" />
      <InputQuery placeholder="Job Type" :items="data.JobTypeData" itemKey="JobType" descKey="JobTypeDesc" :selectedObject.sync="data.selectedJobType" />
      <InputQuery placeholder="Sales Team" :items="data.SalesTeamData" itemKey="Sales Team Code" descKey="Sales Team Name" :selectedObject.sync="data.selectedSalesTeam" />
      <Input placeholder="Sales Person" :inputValue.sync="data.SalesPerson" />
      <InputQuery placeholder="Service Team" :items="data.ServiceTeamData" itemKey="Service Team Code" descKey="Service Team Name" :selectedObject.sync="data.selectedServiceTeam" />
      <Input placeholder="Service Person" :inputValue.sync="data.ServicePerson" />
      <Checkbox title="Default" :isChecked.sync="data.Default" />
    </div>

  </div>

  <!--salesSystem: [],
  salesJobType: [],
  salesTeam: [],
  salesPerson: '',
  salesServiceTeam: [],
  salesServicePerson: '',
  salesDefault: false,
  salesTable: [],-->
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import InputQuery from '@/components/InputQuery.vue';
import Dropdown from '@/components/Dropdown.vue';
import Checkbox from '@/components/CheckBox.vue';
import Tabulator from '@/components/Tabulator.vue';

export default {
  components: {
    Input, InputQuery, Dropdown, Checkbox, Tabulator
  },
  props: {
    viewMode: { type: Boolean, default: false },
    data: { type: Object, default: function() { return {} } },
    selectedTeams: { type: Array, default: function () { return [] } },
    tableSelected: { type: Object, default: function() { return {} } },
    defaultTeamIndex: { type: Object, default: function () { return {} } },
    showDetails: { type: Boolean, default: false },
    okButtonTitle: { type: String, default: 'Default' },
    okButtonAction: { type: String, default: '' },
    additionalButtons: {
      type: Array, default: function () {
        return [
          { value: 'Set Default', type: 'button', index: 0, frozen: true },
          { value: 'Edit', type: 'button', index: 0, frozen: true },
        ]
      }
    },
  },
  mounted() {
    var defaultTeamList = this.data.SalesServiceData.filter((ss) => { return ss['Default'] == 'Y' });
    this.defaultTeamIndex = (defaultTeamList.length > 0) ? this.data.SalesServiceData.indexOf(defaultTeamList[0]) : -1;
  },
  methods: {
    buttonClick: function (action) {
      switch (action) {
        case 'new':
          this.okButtonTitle = 'Save New Team';
          this.okButtonAction = 'new';
          this.clearFields();
          this.showDetails = true;
          //console.log('NEW --------- NEW');
          break;
        case 'edit':
          try {
            this.data['SalesPerson'] = !this.tableSelected['SalesPerson'] ? '' : this.tableSelected['SalesPerson'];
            this.data['ServicePerson'] = !this.tableSelected['ServicePerson'] ? '' : this.tableSelected['ServicePerson'];
            this.data['Default'] = !this.tableSelected['Default'] ? false : (this.tableSelected['Default'] == 'Y' ? true : false);

            this.data['selectedSystem'] = !this.tableSelected['System'] ? null : (this.data['SystemData'].filter((ss) => { return ss['System'].trim() == this.tableSelected['System'].trim() }))[0];
            this.data['selectedJobType'] = !this.tableSelected['JobType'] ? null : (this.data['JobTypeData'].filter((ss) => { return ss['JobType'].trim() == this.tableSelected['JobType'].trim() }))[0];
            this.data['selectedSalesTeam'] = !this.tableSelected['SalesTeam'] ? null : (this.data['SalesTeamData'].filter((ss) => { return ss['Sales Team Code'].trim() == this.tableSelected['SalesTeam'].trim() }))[0];
            this.data['selectedServiceTeam'] = !this.tableSelected['ServiceTeam'] ? null : (this.data['ServiceTeamData'].filter((ss) => { return ss['Service Team Code'].trim() == this.tableSelected['ServiceTeam'].trim() }))[0];
          } catch (e) { console.log(e); };

          this.okButtonTitle = 'Edit Team';
          this.okButtonAction = 'edit';
          this.showDetails = true;
          //console.log('EDIT --------- EDIT');
          break;
        case 'delete':
          //console.log('DELETE --------- DELETE');
          if (this.selectedTeams.length == 0) {
            this.$showAlert('error','No Team(s) Selected', 'Please select Team(s) to delete');
          } else {  this.deleteTeam(this.selectedTeams); }
          break;
        case 'ok':
          switch (this.okButtonAction) {
            case 'new':
              try {
                var teamData = {
                  Default: !this.data['Default'] ? '' : 'Y',
                  System: !this.data['selectedSystem'] ? '' : this.data['selectedSystem']['System'].trim(),
                  JobType: !this.data['selectedJobType'] ? '' : this.data['selectedJobType']['JobType'].trim(),
                  SalesTeam: !this.data['selectedSalesTeam'] ? '' : this.data['selectedSalesTeam']['Sales Team Code'].trim(),
                  SalesPerson: !this.data['SalesPerson'] ? '' : this.data['SalesPerson'].trim(),
                  ServiceTeam: !this.data['selectedServiceTeam'] ? '' : this.data['selectedServiceTeam']['Service Team Code'].trim(),
                  ServicePerson: !this.data['ServicePerson'] ? '' : this.data['ServicePerson'].trim(),
                  CoCode: !this.tableSelected['CoCode'] ? '' : this.tableSelected['CoCode'].trim(),
                };
                this.$set(teamData, 'SalesAction', 'N');
                this.data['SalesServiceData'].push(teamData);
                if (teamData['Default'] == 'Y') { this.setNewDefault(teamData); };
              } catch (e) { console.log(e); };
              break;
            case 'edit':
              try {
                var teamIndex = this.data['SalesServiceData'].indexOf(this.tableSelected);
                var teamData = {
                  Default: !this.data['Default'] ? '' : 'Y',
                  System: !this.data['selectedSystem'] ? '' : this.data['selectedSystem']['System'].trim(),
                  JobType: !this.data['selectedJobType'] ? '' : this.data['selectedJobType']['JobType'].trim(),
                  SalesTeam: !this.data['selectedSalesTeam'] ? '' : this.data['selectedSalesTeam']['Sales Team Code'].trim(),
                  SalesPerson: !this.data['SalesPerson'] ? '' : this.data['SalesPerson'].trim(),
                  ServiceTeam: !this.data['selectedServiceTeam'] ? '' : this.data['selectedServiceTeam']['Service Team Code'].trim(),
                  ServicePerson: !this.data['ServicePerson'] ? '' : this.data['ServicePerson'].trim(),
                  CoCode: !this.tableSelected['CoCode'] ? '' : this.tableSelected['CoCode'].trim(),
                  SalesAction: !this.tableSelected['SalesAction'] ? 'E' : this.tableSelected['SalesAction'].trim(),
                };
                //this.$set(teamData, 'SalesAction', 'E');
                this.data['SalesServiceData'].splice(teamIndex, 1, teamData);
                if (teamData['Default'] == 'Y') { this.setNewDefault(teamData); };
              } catch (e) { console.log(e); };
              break;
          }
          this.clearFields();
          this.showDetails = false;
          //console.log('OK --------- OK');
          break;
        case 'cancel':
          this.clearFields();
          this.showDetails = false;
          //console.log('CANCEL --------- CANCEL');
          break;
      }
    },
    cellClick: function (btn, data) {
      switch (btn) {
        case 'Edit':
          this.tableSelected = data;
          this.buttonClick('edit')
          break;
        case 'Set Default':
          //console.log('DEFAULT --------- DEFAULT');
          this.setNewDefault(data);
          break;
      }
    },
    setNewDefault: function (data) {
      try {
        if (this.defaultTeamIndex >= 0) {
          this.data['SalesServiceData'].forEach((ss) => { this.$set(ss, 'Default', ''); });
          var defaultData = this.data['SalesServiceData'][this.defaultTeamIndex];
          var newData = data; var newIndex = this.data.SalesServiceData.indexOf(newData);
          this.$set(defaultData, 'SalesAction', 'E');
          this.$set(newData, 'SalesAction', (newData['SalesAction'] == '') ? 'E' : newData['SalesAction']);
          this.$set(newData, 'Default', 'Y');
          this.data.SalesServiceData.splice(newIndex, 1, newData);
          this.data.SalesServiceData.splice(this.defaultTeamIndex, 1, defaultData);
        } else {
          this.data['SalesServiceData'].forEach((ss) => { this.$set(ss, 'Default', ''); });
          var newData = data; var newIndex = this.data.SalesServiceData.indexOf(newData);
          this.$set(newData, 'SalesAction', (newData['SalesAction'] == '') ? 'E' : newData['SalesAction']);
          this.$set(newData, 'Default', 'Y');
          this.data.SalesServiceData.splice(newIndex, 1, newData);
        }
      } catch (e) { console.log(e); };
    },
    deleteTeam: async function (data) {
      //-------- Reset Default Teams if main is deleted
      var defaultData = this.data['SalesServiceData'][this.defaultTeamIndex];
      // var response = await this.$alert.questionAlert('Delete Teams', `Are you sure you want to delete selected Teams?`, 'Delete', 'Cancel', 'red');
      var response = await this.$showAlert(
          'warning',
          'Delete Teams',
          'Are you sure you want to delete selected Teams?',
          [{"text" : "Delete"}, {"text" : "Cancel"}]
      );
      if (response === "Delete") {
        data.forEach((ss) => {
          var deleteIndex = this.data['SalesServiceData'].indexOf(ss);
          this.data['SalesServiceData'].splice(deleteIndex, 1);
          if (ss['SalesAction'] != 'N') {
            this.$set(ss, 'SalesAction', 'D');
            this.data['SalesServiceDeleted'].push(ss);
          }
        });
        this.defaultTeamIndex = (this.data['SalesServiceData'].indexOf(defaultData) >= 0) ? this.data['SalesServiceData'].indexOf(defaultData) : -1;
        console.log(this.defaultTeamIndex);
      }
      console.log(this.data['SalesServiceDeleted']);
    },
    clearFields: function () {
      try {
        this.data['SalesPerson'] = '';
        this.data['ServicePerson'] = '';
        this.data['Default'] = false;

        this.data['selectedSystem'] = null;
        this.data['selectedJobType'] = null;
        this.data['selectedSalesTeam'] = null;
        this.data['selectedServiceTeam'] = null;
      } catch (e) { console.log(e); };
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

  .rowBox {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .custSalesMain {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .custSalesDisplay {
    height: 100%;
  }

  .custSalesDetails {
    margin: 0 0 0 5px;
    flex: 1;
    overflow-x: hidden;
  }

  .custSalesTabulatorMain {
    flex: 1;
  }

  .custSalesTabulator {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .buttonBox {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    padding: 10px 0 0 0;
  }

</style>